import { Reveal } from "@/components/Reveal";
import { Crosshair, ShieldCheck, Ship, FileCheck2 } from "lucide-react";
import { SectionHeading } from "@/components/SectionHeading";
import { siteConfig } from "@/data/siteConfig";

const iconMap = { Crosshair, ShieldCheck, Ship, FileCheck2 };

export function WhyChooseUs() {
  return (
    <section className="bg-canvas py-20 lg:py-28" data-testid="why-ocean-exports">
      <div className="mx-auto max-w-7xl px-4 sm:px-6">
        <SectionHeading kicker="Why Ocean Exports" title="Built Around Reliability, Not Guesswork" />
        <div className="mt-14 grid gap-px overflow-hidden border border-[#E3E8EF] bg-[#E3E8EF] sm:grid-cols-2 lg:grid-cols-4">
          {siteConfig.why.map((w, i) => {
            const Icon = iconMap[w.icon] || Crosshair;
            return (
              <Reveal key={w.title} delay={i * 0.08} className="group relative bg-white p-8 lg:p-9 transition-colors duration-300 hover:bg-ink">
                <span className="absolute right-5 top-5 font-display text-sm font-bold text-[#D6DCE4] group-hover:text-amber transition-colors">0{i + 1}</span>
                <Icon className="w-9 h-9 text-amber-hover" strokeWidth={1.5} />
                <h3 className="mt-6 font-display uppercase text-xl tracking-wide text-ink group-hover:text-white transition-colors">{w.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted group-hover:text-white/70 transition-colors">{w.desc}</p>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
